import React from 'react'
import { datalayerHandler } from '../../../../utils/datalayer'
import { Image } from '../../../../utils/image'
import { Link } from '../../../../utils/link'
import { quoteBlockClasses } from '../../../../utils/style'
import { getClassName, htmlDecode } from '../../../../utils/utils'
import { useInView } from '../../../hooks/useInView'
import { QuoteBlock } from '../blocksState'

export type QuoteBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  quoteClassName: string
  quoteTextClassName: string
  footerClassName: string
  authorClassName: string
  clickableWrapperClassName: string
  clickableClassName: string
  clickableLabelClassName: string
  clickableIconClassName: string
  visualClassName: string
  imageClassName: string
  pictureClassName: string
  iconId: string
}>

export const QuoteBlockLayout = (props: QuoteBlock) => {
  const { author, image, inview, index, primaryAction, text } = props
  const classes = quoteBlockClasses(image !== undefined)
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("QuoteBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <figure
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', `py-5${image ? ' row' : ''}`)}>
        {(text || author || primaryAction) && (
          <div className={getClassName(classes, 'contentClassName', `${image ? 'col-md-6 mb-4' : 'text-center'}`)}>
            {text && (
              <blockquote className={getClassName(classes, 'quoteClassName', '')}>
                <p className={getClassName(classes, 'quoteTextClassName', 'h4')}>{htmlDecode(text)}</p>
              </blockquote>
            )}

            {author && (
              <figcaption className={getClassName(classes, 'authorClassName', 'mb-3 text-muted')}>
                <cite>{author}</cite>
              </figcaption>
            )}

            {primaryAction && primaryAction.title && (
              <footer className={getClassName(classes, 'footerClassName', '')}>
                <div className={getClassName(classes, 'clickableWrapperClassName', 'd-inline-block')}>
                  <Link
                    url={primaryAction.url}
                    title={primaryAction.title}
                    className={getClassName(classes, 'clickableClassName', 'btn btn-dark d-inline-flex')}
                    additionalOnClick={() =>
                      datalayerHandler('quote', undefined, undefined, {
                        kind: 'link',
                        link: primaryAction.url,
                        label: primaryAction.title,
                      })
                    }
                  >
                    <span className={getClassName(classes, 'clickableLabelClassName', '')}>
                      {htmlDecode(primaryAction.title)}
                    </span>
                    {primaryAction.SVGIcon && (
                      <svg
                        className={getClassName(classes, 'clickableIconClassName', 'ml-3')}
                        aria-hidden="true"
                        width={primaryAction.SVGIcon.width ? primaryAction.SVGIcon.width : '24px'}
                        height={primaryAction.SVGIcon.height ? primaryAction.SVGIcon.height : '24px'}
                      >
                        <use xlinkHref={getClassName(classes, 'iconId', '#icon--chevron-right-large')} />
                      </svg>
                    )}
                  </Link>
                </div>
              </footer>
            )}
          </div>
        )}

        {image && (
          <div className={getClassName(classes, 'visualClassName', 'col-md-6 mb-4')}>
            <Image
              {...image}
              classNames={{
                image: getClassName(classes, 'imageClassName', 'w-100'),
                picture: getClassName(classes, 'pictureClassName', ''),
              }}
            />
          </div>
        )}
      </div>
    </figure>
  )
}
